export const SUGGESTED = 'SUGGESTED';
export const TABLES = 'TABLES';
export const SAVED_QUERIES = 'SAVED_QUERIES';
